import React from "react";
import { Nav, NavItem } from "reactstrap";
import { CheckCircle, FilePlus, Trash } from "react-feather";
import { Badges, Btn } from "../../../../AbstractElements";
import { Href, ToDoList } from "../../../../Utils/Constants";
import { useTodoFilter } from "../../../../Features/todo/context/TodoFilterContext";
import { useTaskList } from "../../../../Features/todo/hooks/useTaskList";

export default function TodoNav() {
  const { filter, setFilter } = useTodoFilter();
  const { data } = useTaskList();

  
  const totale = data?.totale ?? 0;
  const completati = data?.completato ?? 0;
  const cancellati = data?.cancellati ?? 0;
  // const daFare = totale - completati - cancellati;
  const daFare = totale;

  return (
    <Nav className="main-menu">
      <NavItem>
        <Btn color="primary" block className="btn-mail w-100">
          <CheckCircle className="me-2" /> {ToDoList}
        </Btn>
      </NavItem>

      <NavItem>
        <a
          href={Href}
          onClick={(e) => { e.preventDefault(); setFilter("todo"); }}
          className={`nav-link ${filter === "todo" ? "active" : ""}`}
        >
          <span className="iconbg badge-light-primary"><FilePlus /></span>
          <span className="title ms-2">Task da fare</span>
          <Badges color="primary">{daFare}</Badges>
        </a>
      </NavItem>

      <NavItem>
        <a
          href={Href}
          onClick={(e) => { e.preventDefault(); setFilter("completed"); }}
         className={`nav-link ${filter === "completed" ? "active" : ""}`}
        >
          <span className="iconbg badge-light-success"><CheckCircle /></span>
          <span className="title ms-2">Completati</span>
          <Badges color="success">{completati}</Badges>
        </a>
      </NavItem>

      <NavItem>
        <a
          href={Href}
          onClick={(e) => { e.preventDefault(); setFilter("deleted"); }}
          className={`nav-link ${filter === "deleted" ? "active" : ""}`}
        >
          <span className="iconbg badge-light-danger"><Trash /></span>
          <span className="title ms-2">Cancellati</span>
          <Badges color="danger">{cancellati}</Badges>
        </a>
      </NavItem>
    </Nav>
  );
}
